<div class="littleAboutUs" [ngClass]="{'showHiddenMessage' : showHiddenMessage}">
    <div class="mw">
        <div class="d-flex justify-content-end row popGirl">
            <div class="sm-12 md-12 xl-8" [ngClass]="{'offset-2' : brand === 'winaija' && !isMobile}">
                <div class="mobile-container" [ngClass]="{'center' : brand === 'winaija' && !isMobile}">
                    <h2 class="color-prussian-blue">{{ 'static.lau' | translate }}</h2>
                    <p>{{ 'static.lauBody' | translate }}</p>
                </div>

                <!--MOBILE-->
                <div class="mobile-show security-header">
                    <img src="../../../assets/images/newCircleIcons/shield.png"/>
                    <h4 class="color-sapphire">{{ 'static.security' | translate }}</h4>
                </div>
                <!--END MOBILE-->

                <div class="row icons">
                    <div class="fl sm-6 md-6 xl-6">
                        <div class="row">
                            <div class="fl sm-3 md-3 xl-3">
                                <img src="../../../assets/images/newCircleIcons/shield.png"/>
                            </div>
                            <div class="fl sm-9 md-9 xl-9">
                                <h4 class="color-sapphire">{{ 'static.secure' | translate }}</h4>
                                <p>{{ 'static.secureBody' | translate }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="fl sm-6 md-6 xl-6">
                        <div class="row">
                            <div class="fl sm-3 md-3 xl-3">
                                <img src="../../../assets/images/newCircleIcons/badge.png"/>
                            </div>
                            <div class="fl sm-9 md-9 xl-9">
                                <h4 class="color-sapphire">{{ 'static.mbg' | translate }}</h4>
                                <p>{{ 'static.mbgBody' | translate }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="fl sm-6 md-6 xl-6">
                        <div class="row">
                            <div class="fl sm-3 md-3 xl-3">
                                <img src="../../../assets/images/newCircleIcons/satisfy.png"/>
                            </div>
                            <div class="fl sm-9 md-9 xl-9">
                                <h4 class="color-pomegranate">{{ 'static.cs' | translate }}</h4>
                                <p>{{ 'static.csBody' | translate }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="fl sm-6 md-6 xl-6">
                        <div class="row">
                            <div class="fl sm-3 md-3 xl-3">
                                <img (click)="count()" src="../../../assets/images/newCircleIcons/support.png"/>
                            </div>
                            <div class="fl sm-9 md-9 xl-9">
                                <h4 class="color-venice-blue">{{ 'static.spam' | translate }}</h4>
                                <p>{{ 'static.spamBody' | translate }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
